<nv-date-range-picker
  *ngIf="(dateLimitConfig$ | async) as config"
  [dateRangeForm]="dateRangeForm"
  [startLimit]="config.startLimit"
  [endLimit]="config.endLimit"
></nv-date-range-picker>